module.exports = __webpack_public_path__ + "img/bring-front.d11bf684.svg";